import { useIsomorphicLayoutEffect } from '@/hooks/useIsomorphicLayoutEffect';
import { InternalClassName } from '@/shared/constant/InternalClassName';
import { useSidebarTreeStore } from '../../store/sidebarTreeStore';
import { generateClassNameBySidebarTreeNodeKey } from '../../util/generateClassNameBySidebarTreeNodeKey';

export function SidebarTreeNodeScrollAnchor() {
  const selectedSidebarTreeNodeKey = useSidebarTreeStore((x) => x.selectedKey);
  const getSelectedTime = useSidebarTreeStore((x) => x.getSelectedTime);
  useIsomorphicLayoutEffect(() => {
    let timer = -1;
    if (selectedSidebarTreeNodeKey) {
      const selectedTime = getSelectedTime();
      if (Math.abs(new Date().getTime() - selectedTime) < 100) {
        return;
      }

      timer = window.setTimeout(() => {
        const selectedNode: HTMLDivElement | null = document.querySelector(
          `.${generateClassNameBySidebarTreeNodeKey(selectedSidebarTreeNodeKey)}`,
        );
        const treeScrollContainer = document.querySelector(
          `.${InternalClassName.TreeScrollContainer}`,
        );
        if (selectedNode && treeScrollContainer) {
          treeScrollContainer.scrollTo({
            top: selectedNode.offsetTop - 200,
          });
        }
      }, 5);
    }

    return () => {
      clearTimeout(timer);
    };
  }, [selectedSidebarTreeNodeKey]);

  return null;
}
